import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getShareHostState, mirrorRoute, broadcastFrame } from '../services/shareHostStore.js';
import { onShareFrame } from '../services/shareBus.js';

/**
 * ShareBroadcaster — app-lifetime HOST mirror (post-launch fix).
 *
 * Owns the two frame sources while a share is active, independent of whether
 * the ShareModal is open (the old modal-scoped broadcaster silently died when
 * the host closed the modal — viewers sat on "Waiting…" forever):
 *
 *   1. shareBus frames: screens with live content (chat, website builder)
 *      emit richer frames; forwarded verbatim to the broadcast loop.
 *   2. Route changes: every navigation mirrors the new screen, so a host who
 *      is just sitting on any screen still broadcasts (presence frames).
 *
 * Mounts once inside the authenticated workspace shell. Renders nothing.
 */
export default function ShareBroadcaster({ businessName }) {
  const location = useLocation();

  // 1. Forward richer screen-emitted frames through the broadcast loop.
  useEffect(() => onShareFrame((frame) => {
    if (getShareHostState().shareId) broadcastFrame(frame.screenSlug, frame.payload);
  }), []);

  // 2. Route changes always mirror (screen slug + overview payload).
  useEffect(() => {
    if (getShareHostState().shareId) mirrorRoute(location.pathname, businessName);
  }, [location.pathname, businessName]);

  return null;
}
